import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import CurrencyBitcoinOutlinedIcon from '@mui/icons-material/CurrencyBitcoinOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import KeyboardDoubleArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftOutlined';
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import PasswordOutlinedIcon from '@mui/icons-material/PasswordOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import ReportOutlinedIcon from '@mui/icons-material/ReportOutlined';
import RequestPageOutlinedIcon from '@mui/icons-material/RequestPageOutlined';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import SportsBasketballOutlinedIcon from '@mui/icons-material/SportsBasketballOutlined';
import SportsMmaOutlinedIcon from '@mui/icons-material/SportsMmaOutlined';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import TopicAvailableOutlinedIcon from '@mui/icons-material/TopicOutlined';
import ViewCarouselOutlinedIcon from '@mui/icons-material/ViewCarouselOutlined';
import YouTubeIcon from '@mui/icons-material/YouTube';
import {Box, IconButton, Stack, Tooltip} from '@mui/material';

import {
  ROUTE__BANNERS,
  ROUTE__BASKETBALL,
  ROUTE__CATEGORIES,
  ROUTE__CATEGORIES_GROUP,
  ROUTE__CRYPTO,
  ROUTE__EVENTS,
  ROUTE__GEO_FILTER_OPTIONS,
  ROUTE__KYC,
  ROUTE__MARKETPLACE,
  ROUTE__ONBOARDINGS,
  ROUTE__ORDERS,
  ROUTE__PARTICIPANTS,
  ROUTE__PROMOCODES,
  ROUTE__RATES,
  ROUTE__REFERRALS,
  ROUTE__REPORTS,
  ROUTE__SETTINGS,
  ROUTE__SETTINGS_COUNTRIES,
  ROUTE__SETTINGS_PAYMENT_METHODS,
  ROUTE__SETTINGS_VOUCHERS,
  ROUTE__SPORT_MATCHES,
  ROUTE__STAKES,
  ROUTE__TOPICS,
  ROUTE__TRANSACTIONS,
  ROUTE__USER_BANS,
  ROUTE__USERS,
  ROUTE__VIDEOS,
} from '@shared/constants';
import {NavigationLink} from './NavigationLink';
import {SubMenu} from './SubMenu';

interface Props {
  isCollapsed: boolean;
  onCollapsedChange: (isCollapsed: boolean) => void;
}

export const SideBar = ({isCollapsed, onCollapsedChange}: Props) => {
  const subMenuProps = {
    isCollapsed,
    onExpandSidebar: () => {
      onCollapsedChange(false);
    },
  };

  return (
    <Box px={isCollapsed ? 1 : 2} py={2} position="sticky" top={0}>
      <Box
        display="flex"
        justifyContent={isCollapsed ? 'center' : 'flex-end'}
        mb={1}
      >
        <Tooltip
          title={isCollapsed ? 'Expand menu' : 'Collapse menu'}
          placement="right"
        >
          <IconButton
            size="small"
            onClick={() => {
              onCollapsedChange(!isCollapsed);
            }}
          >
            {isCollapsed ? (
              <KeyboardDoubleArrowRightOutlinedIcon />
            ) : (
              <KeyboardDoubleArrowLeftOutlinedIcon />
            )}
          </IconButton>
        </Tooltip>
      </Box>

      <Stack spacing={2} component="nav">
        <SubMenu
          {...subMenuProps}
          text="Support"
          icon={<SupportAgentOutlinedIcon />}
          defaultOpen
          groupRoutes={[
            ROUTE__USERS,
            ROUTE__USER_BANS,
            ROUTE__REPORTS,
            ROUTE__ORDERS,
            ROUTE__STAKES,
            ROUTE__KYC,
            ROUTE__PROMOCODES,
            ROUTE__TRANSACTIONS,
            ROUTE__RATES,
          ]}
        >
          <NavigationLink
            route={ROUTE__USERS}
            text="Accounts"
            icon={<GroupOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__PROMOCODES}
            text="Promo-codes"
            icon={<PasswordOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__ORDERS}
            text="Orders"
            icon={<RequestPageOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__STAKES}
            text="Stakes"
            icon={<SavingsOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__TRANSACTIONS}
            text="Transactions"
            icon={<CardGiftcardOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__KYC}
            text="KYC"
            icon={<FactCheckOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__RATES}
            text="Rates"
            icon={<StarBorderOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__USER_BANS}
            text="User bans"
            icon={<ReportOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__REPORTS}
            text="Reports"
            icon={<ReportOutlinedIcon />}
          />
        </SubMenu>

        <SubMenu
          {...subMenuProps}
          text="Content"
          icon={<CategoryOutlinedIcon />}
          groupRoutes={[
            ROUTE__TOPICS,
            ROUTE__EVENTS,
            ROUTE__SPORT_MATCHES,
            ROUTE__BASKETBALL,
            ROUTE__CATEGORIES_GROUP,
            ROUTE__PARTICIPANTS,
            ROUTE__BANNERS,
            ROUTE__VIDEOS,
            ROUTE__CRYPTO,
            ROUTE__ONBOARDINGS,
          ]}
        >
          <NavigationLink
            route={ROUTE__TOPICS}
            text="Topics"
            icon={<TopicAvailableOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__EVENTS}
            text="Events"
            icon={<EventAvailableOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__BASKETBALL}
            text="Basketball"
            icon={<SportsBasketballOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__CATEGORIES}
            text="Categories"
            icon={<SportsMmaOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__PARTICIPANTS}
            text="Participants"
            icon={<PeopleOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__GEO_FILTER_OPTIONS}
            text="Geo"
            icon={<PublicOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__BANNERS}
            text="Banners"
            icon={<ViewCarouselOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__VIDEOS}
            text="Youtube"
            icon={<YouTubeIcon />}
          />

          <NavigationLink
            route={ROUTE__CRYPTO}
            text="Crypto"
            icon={<CurrencyBitcoinOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__ONBOARDINGS}
            text="Onboarding"
            icon={<MenuBookOutlinedIcon />}
          />
        </SubMenu>

        <SubMenu
          {...subMenuProps}
          text="Social"
          icon={<HandshakeOutlinedIcon />}
          groupRoutes={[ROUTE__REFERRALS, ROUTE__MARKETPLACE]}
        >
          <NavigationLink
            route={ROUTE__REFERRALS}
            text="Referrals"
            icon={<ShareOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__MARKETPLACE}
            text="Marketplace"
            icon={<StorefrontOutlinedIcon />}
          />
        </SubMenu>

        <SubMenu
          {...subMenuProps}
          text="Settings"
          icon={<SettingsOutlinedIcon />}
          groupRoutes={[ROUTE__SETTINGS]}
        >
          <NavigationLink
            route={ROUTE__SETTINGS_COUNTRIES}
            text="Countries"
            icon={<FlagOutlinedIcon />}
          />

          <NavigationLink
            route={ROUTE__SETTINGS_PAYMENT_METHODS}
            text="Payment methods"
            icon={<PaymentsOutlinedIcon />}
          />
          <NavigationLink
            route={ROUTE__SETTINGS_VOUCHERS}
            text="Voucher configs"
            icon={<CardGiftcardOutlinedIcon />}
          />
        </SubMenu>
      </Stack>
    </Box>
  );
};
